import {
  useMutation,
  type QueryKey,
  type UseMutationOptions,
  type UseMutationResult,
} from '@tanstack/react-query';
import { AxiosError, AxiosResponse } from 'axios';

import { api } from '@/utils/api';
import { ApiErrorResponse, ApiResponse } from '@/types/api';

export interface UpdateClientShareRequest {
  clientId: number;
  type: 'file' | 'link';
  id: number;
}

export const updateClientShare = ({
  clientId,
  type,
  id,
}: UpdateClientShareRequest) => {
  return api.put<ApiResponse<undefined>>('/client/share', {
    clientId,
    type,
    id,
  });
};

const useUpdateClientShare = <TError = AxiosError<ApiErrorResponse>>(
  options?: UseMutationOptions<
    AxiosResponse<ApiResponse<undefined>>,
    TError,
    UpdateClientShareRequest,
    QueryKey
  >,
): UseMutationResult<
  AxiosResponse<ApiResponse<undefined>>,
  TError,
  UpdateClientShareRequest,
  QueryKey
> => {
  return useMutation(updateClientShare, {
    ...options,
  });
};

export default useUpdateClientShare;
